import { render, staticRenderFns } from "./PageIntroTemplate.vue?vue&type=template&id=0383b210&scoped=true"
import script from "./PageIntroTemplate.vue?vue&type=script&lang=js"
export * from "./PageIntroTemplate.vue?vue&type=script&lang=js"
import style0 from "./PageIntroTemplate.vue?vue&type=style&index=0&id=0383b210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383b210",
  null
  
)

export default component.exports